import type { ProductDimensionsModule } from '@orus.eu/dimensions'
import { esMrpaxeDimensionsModule } from '@orus.eu/dimensions-es-mrpaxe'
import { esMrpwDimensionsModule } from '@orus.eu/dimensions-es-mrpw'
import { esRcphDimensionsModule } from '@orus.eu/dimensions-es-rcph'
import { frAupaDimensionsModule } from '@orus.eu/dimensions-fr-aupa'
import { frMrgaDimensionsModule } from '@orus.eu/dimensions-fr-mrga'
import { frMrpaxeDimensionsModule } from '@orus.eu/dimensions-fr-mrpaxe'
import { frPrelDimensionsModule } from '@orus.eu/dimensions-fr-prel'
import { frRccwDimensionsModule } from '@orus.eu/dimensions-fr-rccw'
import { frRcpaxeDimensionsModule } from '@orus.eu/dimensions-fr-rcpaxe'
import { frRcpwDimensionsModule } from '@orus.eu/dimensions-fr-rcpw'
import { mrpaDimensionsModule } from '@orus.eu/dimensions-mrpa'
import { mrphDimensionsModule } from '@orus.eu/dimensions-mrph'
import { mrpwDimensionsModule } from '@orus.eu/dimensions-mrpw'
import { mutaDimensionsModule } from '@orus.eu/dimensions-muta'
import { nlAovqlDimensionsModule } from '@orus.eu/dimensions-nl-aovql'
import { nlRcphDimensionsModule } from '@orus.eu/dimensions-nl-rcph'
import { rcdaDimensionsModule } from '@orus.eu/dimensions-rcda'
import { rcpaDimensionsModule } from '@orus.eu/dimensions-rcpa'
import { rcpaxaDimensionsModule } from '@orus.eu/dimensions-rcpaxa'
import { rcphDimensionsModule } from '@orus.eu/dimensions-rcph'
import type { Product } from '@orus.eu/product'
import { objectValues } from '@orus.eu/utils'

export const productDimensionsModuleByProduct = {
  rcph: rcphDimensionsModule,
  muta: mutaDimensionsModule,
  rcda: rcdaDimensionsModule,
  'es-rcph': esRcphDimensionsModule,
  rcpa: rcpaDimensionsModule,
  rcpaxa: rcpaxaDimensionsModule,
  'fr-prel': frPrelDimensionsModule,
  'fr-rcpw': frRcpwDimensionsModule,
  'nl-rcph': nlRcphDimensionsModule,
  mrph: mrphDimensionsModule,
  mrpw: mrpwDimensionsModule,
  mrpa: mrpaDimensionsModule,
  'es-mrpw': esMrpwDimensionsModule,
  'fr-rccw': frRccwDimensionsModule,
  'nl-aovql': nlAovqlDimensionsModule,
  'fr-aupa': frAupaDimensionsModule,
  'fr-mrga': frMrgaDimensionsModule,
  'fr-mrpaxe': frMrpaxeDimensionsModule,
  'fr-rcpaxe': frRcpaxeDimensionsModule,
  'es-mrpaxe': esMrpaxeDimensionsModule,
} satisfies Record<Product, ProductDimensionsModule>

export const productDimensionsModules = objectValues(productDimensionsModuleByProduct)
